module.exports = __webpack_public_path__ + "2021525:777057f5211ffb5bd912/img/featured_image@1x.c400bcd.jpg";